export const SPECIAL_CHAR_ERROR =
	'Invalid phone number. Special characters, spaces, and symbols are not allowed.';
export const LENGTH_ERROR =
	'Invalid phone number. Please enter a valid phone number between 4 and 15 digits.';
export const GENERAL_ERROR =
	'Invalid phone number. Please enter a valid phone number between 4 and 15 digits. Special characters, spaces, and symbols are not allowed.';
